import {defineMessages} from 'react-intl';

export default defineMessages({
	emailNotFound: {
		id: 'forms.fields.email.noempty',
		defaultMessage: 'Please enter your email address',
	},
	emailIsInvalid: {
		id: 'forms.fields.email.noinvalid',
		defaultMessage: 'Please enter a valid email address',
	},
	emailAlreadyInUse: {
		id: 'forms.fields.email.alreadyInUse',
		defaultMessage: 'Username already taken.',
	},
	passwordNotFound: {
		id: 'forms.fields.password.noempty',
		defaultMessage: 'Please enter your password',
	},
	latinCharactersError: {
		id: 'forms.fields.name.error.latinCharacters',
		defaultMessage: 'Please enter Latin characters only',
	},
	noNumbers: {
		id: 'forms.fields.name.error.noNumbers',
		defaultMessage: 'Please do not use numbers',
	},
	minLength: {
		id: 'forms.fields.name.error.minLength',
		defaultMessage: 'Please write at least 2 characters',
	},
	noSpecialChars: {
		id: 'forms.fields.name.error.noSpecialChars',
		defaultMessage: 'Please do not use special characters',
	},
	submit: {
		id: 'auth.signup.submit',
		defaultMessage: 'Create Account',
	},
	title: {
		id: 'auth.signup.title',
		defaultMessage: 'Create account',
	},
	titleNotFound: {
		id: 'forms.fields.title.noempty',
		defaultMessage: 'Please enter a Title',
	},
	unexpectedError: {
		id: 'common.error.unexpected',
		defaultMessage: 'An unexpected error occurred. Try again later.',
	},
	birthdayNotFound: {
		id: 'forms.fields.birthday.error.noempty',
		defaultMessage: 'Please enter your birthday',
	},
	birthdayIsInvalid: {
		id: 'forms.fields.birthday.error.invalid',
		defaultMessage: 'Please enter the correct date',
	},
	recall: {
		id: 'auth.signup.recall',
		defaultMessage: 'I Already Have It',
	},
});
